var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 22112,
    height: 2474,
    transform: "translate(-8177 -237)",
    fill: "#C1CEFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_32)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 862,
    transform: "translate(-341 -141)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 971,
    height: 782,
    transform: "translate(-32 -61)",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_57_32)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 971,
    height: 782,
    transform: "translate(-32 -61)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -16,
    width: 939,
    height: 106,
    rx: 16,
    fill: "#00597B",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#00597B",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 9.33398C9.79151 9.33398 8.00065 11.1248 8.00065 13.334V16.0007C8.00065 16.1609 8.01007 16.3189 8.02839 16.4742C8.00993 16.5353 8 16.6002 8 16.6673V22.5512C8 23.1207 8.66808 23.428 9.10053 23.0573L12.1049 20.4821C12.4674 20.1714 12.9291 20.0007 13.4065 20.0007H20.0007C22.2098 20.0007 24.0007 18.2098 24.0007 16.0007V13.334C24.0007 11.1248 22.2098 9.33398 20.0007 9.33398H12.0007Z",
    stroke: "#05232E",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 862,
    fill: "white",
    transform: "translate(-341 -141)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_57_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 971,
    height: 782,
    fill: "white",
    transform: "translate(-32 -61)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/IconMessage.ff217f664bbef67ffd9ec8ef9cc6c586.svg";
export { ForwardRef as ReactComponent };